import { MoreThick } from 'almanac-ui/icons/16'
import { Divider } from 'common/Prose/Toolbar/components/Divider/Divider'
import { DropdownTrigger } from 'components/DropdownTrigger/DropdownTrigger'
import { InlineFormatButton } from 'components/InlineFormatBar/components/InlineFormatButton/InlineFormatButton'
import { EditorView } from 'prosemirror-view'
import { ArticleFlat } from 'types'
import { ClearFormattingFormatButton } from './Buttons/ClearFormattingFormatButton'
import { DeleteTextInlineFormatButton } from './Buttons/DeleteTextInlineFormatButton'
import { DuplicateTextInlineFormatButton } from './Buttons/DuplicateTextInlineFormatButton'
import { InlineCodeInlineFormatButton } from './Buttons/InlineCodeInlineFormatButton'
import { InlineCopyBlockLinkFormatButton } from './Buttons/InlineCopyBlockLinkFormatButton'
import { LastEditedByInlineFormatItem } from './Buttons/LastEditedByInlineFormatItem'
import { StrikethroughFormatButton } from './Buttons/StrikethroughFormatButton'
import { SubscriptInlineFormatButton } from './Buttons/SubscriptInlineFormatButton'
import { SuperscriptInlineFormatButton } from './Buttons/SuperscriptInlineFormatButton'
import { UnderlineInlineFormatButton } from './Buttons/UnderlineInlineFormatButton'
import Styles from './MoreOptionsDropdown.module.scss'

export const MoreOptionsDropdown = ({ view, article }: { view: EditorView; article: ArticleFlat }) => {
  return (
    <DropdownTrigger noOverlay popoverClassName={Styles.dropdownContainer} placement="bottom-end" autoFocus={false}>
      <InlineFormatButton aria-label="Format Menu More options" data-testid="Format Menu More options" size="md">
        <MoreThick />
      </InlineFormatButton>
      {(close) => (
        <>
          <StrikethroughFormatButton view={view} callback={close} />
          <UnderlineInlineFormatButton view={view} callback={close} />
          <InlineCodeInlineFormatButton view={view} callback={close} />
          <SuperscriptInlineFormatButton view={view} callback={close} />
          <SubscriptInlineFormatButton view={view} callback={close} />
          <ClearFormattingFormatButton view={view} callback={close} />
          <Divider className={Styles.divider} />
          <DuplicateTextInlineFormatButton view={view} callback={close} />
          <InlineCopyBlockLinkFormatButton view={view} callback={close} />
          <DeleteTextInlineFormatButton view={view} callback={close} />
          <Divider className={Styles.divider} />
          <LastEditedByInlineFormatItem />
        </>
      )}
    </DropdownTrigger>
  )
}
